<template>
  <MoreOptionsMenuButton
    v-bind="attrs"
    v-if="
      currentUser?.hasPermission('fleet.change_vehicle') ||
      currentUser?.hasPermission('fleet.delete_vehicle')
    "
  >
    <v-list-item
      v-if="currentUser.hasPermission('fleet.change_vehicle')"
      @click="emit('vehicle-edit-pressed', vehicle)"
      title="Edit Vehicle"
    >
      <template #prepend>
        <v-icon size="18" icon="mdi-pencil" class="me-1" />
      </template>
    </v-list-item>

    <template v-if="currentUser.hasPermission('fleet.delete_vehicle')">
      <v-divider class="pb-1" />
      <v-list-item
        class="text-error"
        @click="emit('vehicle-delete-pressed', vehicle)"
        title="Delete Vehicle"
      >
        <template #prepend>
          <v-icon size="18" icon="mdi-delete" class="me-1" />
        </template>
      </v-list-item>
    </template>
  </MoreOptionsMenuButton>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import { storeToRefs } from 'pinia'

import type { IVehicle } from '@/models/fleet-management'

import { useAuthStore } from '@/stores'

import MoreOptionsMenuButton from '@/components/common/MoreOptionsMenuButton.vue'

interface Props {
  vehicle: IVehicle
}
defineProps<Props>()

interface Emit {
  (e: 'vehicle-edit-pressed', vehicle: IVehicle): void
  (e: 'vehicle-delete-pressed', vehicle: IVehicle): void
}

const emit = defineEmits<Emit>()

const attrs = useAttrs()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
</script>
